import React from "react";
import { IInspectionResponseModel } from "../../../typings/models/InspectionResponseModel";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { updateInspectionStatus } from "../../../api/apimethods";

interface GridRowProps {
  data: IInspectionResponseModel;
}

const VetHealthInspectionGridRow: React.FC<GridRowProps> = ({ data }) => {
  let navigate = useNavigate();

  const handleAmendClick = (id: string) => {
    let path = `/vethealth-inspections`;
    navigate(path, { state: { id: id, mode: "amend" } });
  };

  const handleViewClick = (id: string) => {
    let path = `/vethealth-inspections`;
    navigate(path, { state: { id: id, mode: "view" } });
  };

  const handleWithdrawClick = async (id: string, caseNo: string) => {
    if (window.confirm("Are you sure you want to cancel the inspection?")) {
      var response = null;
      response = await updateInspectionStatus(
        id,
        13 // withdraw
      );
      if (response.data) {
        let inspectionNumber = caseNo;
        let path = `/vethealth-inspection-complete`;
        navigate(path, {
          state: { type: "Dashboard", inspectionCaseNo: caseNo },
        });
      } else {
        // API call failed
        const errorMessage = "An error occurred. Please try again.";
        alert(errorMessage); // Set the error message in state
      }
    }
  };

  const fixTimezoneOffset = (date: Date | null): Date | null => {
    if (!date) return null;
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  };

  const getTimezoneOffset = (date: Date): Date | null => {
    const newDate = new Date(date);
    const userTimezoneOffset = Math.abs(newDate.getTimezoneOffset() * 60000);
    return new Date(newDate.getTime() - userTimezoneOffset);
  };

  return (
    <tr>
      <td>{data.inspectionCaseNumber}</td>
      <td>{data.salutation}</td>
      <td>{data.name}</td>
      {/*<td>{data.uen}</td>
      <td>{data.companyName}</td>
      <td>{data.organisationalAddress}</td>*/}
      <td>{data.mobileNo}</td>
      <td>
        {data.inspectionStatus === 1 && "Pending Inspection"}
        {data.inspectionStatus === 2 && "Pending Lab Test"}
        {data.inspectionStatus === 3 && "Completed Inspection"}
        {data.inspectionStatus === 4 && "Inspection Withdrawn"}
        {data.inspectionStatus === 5 && "Pending Verification"}
        {data.inspectionStatus === 6 && "Pending Submission"}
        {data.inspectionStatus === 7 && "Pending Rectification Action"}
        {data.inspectionStatus === 8 && "Inspection Terminated"}
        {data.inspectionStatus === 9 && "Inspection Waived"}
        {data.inspectionStatus === 10 && "Requires Amendment"}
        {data.inspectionStatus === 11 && "Pending iAO Approval"}
        {data.inspectionStatus === 12 && "No Show"}
        {data.inspectionStatus === 13 && "Cancelled Inspection"}
      </td>
      <td>{data.inspectionLocation}</td>
      <td>
        {data.insAppHarvestDate != null
          ? moment(getTimezoneOffset(new Date(data.insAppHarvestDate))).format(
              "DD/MM/YYYY hh:mm A"
            )
          : ""}
      </td>
      {/* <td>{data.insAppModeofContact}</td> */}
      <td>
        <a href="#" onClick={() => handleViewClick(data.inspectionCaseId)}>
          View
        </a>{" "}
        {data.allowAmend && (
          <a href="#" onClick={() => handleAmendClick(data.inspectionCaseId)}>
            Amend
          </a>
        )}{" "}
        {data.allowCancel && (
          <a
            href="#"
            onClick={() =>
              handleWithdrawClick(
                data.inspectionCaseId,
                data.inspectionCaseNumber
              )
            }
          >
            Cancel
          </a>
        )}
      </td>
      {/* Add other data fields here */}
    </tr>
  );
};

export default VetHealthInspectionGridRow;
